import { v4 as uuid } from 'uuid';

export interface ITaxCertificationDelinquenciesResponse {
  id?: string;
  createdAt?: string;
  taxYear?: number;
  installNumber?: string;
  billingPeriodStart?: string;
  billingPeriodEnd?: string;
  taxesBilledCents?: number;
  taxesPaidCents?: number;
  dueDate?: string;
  status?: string;
}

export interface ITaxCertificationDelinquenciesData {
  id?: string;
  createdAt?: string;
  taxYear?: number;
  installNumber?: string;
  billingPeriodStart?: string;
  billingPeriodEnd?: string;
  taxesBilledCents?: number;
  taxesPaidCents?: number;
  dueDate?: string;
  status?: string;
}

export const createDefaultTaxCertificationDelinquenciesData = (): ITaxCertificationDelinquenciesData => ({
  id: uuid(),
});

export const convertTaxCertificationDelinquenciesResponseToTaxCertificationDelinquenciesData = (
  res: ITaxCertificationDelinquenciesResponse
): ITaxCertificationDelinquenciesData => ({
  id: res.id,
  createdAt: res.createdAt,
  taxYear: res.taxYear,
  installNumber: res.installNumber,
  billingPeriodStart: res.billingPeriodStart,
  billingPeriodEnd: res.billingPeriodEnd,
  taxesBilledCents: res.taxesBilledCents,
  taxesPaidCents: res.taxesPaidCents,
  dueDate: res.dueDate,
  status: res.status,
});

export const convertTaxCertificationDelinquenciesDataToTaxCertificationDelinquenciesResponse = (
  data: ITaxCertificationDelinquenciesData
): ITaxCertificationDelinquenciesResponse => ({
  id: data.id,
  createdAt: data.createdAt,
  taxYear: data.taxYear,
  installNumber: data.installNumber,
  billingPeriodStart: data.billingPeriodStart,
  billingPeriodEnd: data.billingPeriodEnd,
  taxesBilledCents: data.taxesBilledCents,
  taxesPaidCents: data.taxesPaidCents,
  dueDate: data.dueDate,
  status: data.status,
});
